/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return*/

import { DEFAULT_VALUE_OPTION, instance4 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import { useState, useEffect } from "react";

const getAllMasterSupplier = async (url) => {
  try {
    const api = await instance4.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

const useInitialMasterSupplier = (
  withSearch = false,
  url = "/wmsmaster/supplier/read",
  type = "all"
) => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Supplier");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await getAllMasterSupplier(url);
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Supplier",
              },
            ];

        if (type === "all") {
          res.map((item) => {
            return data.push({
              value: item.id,
              label: item.name,
            });
          });
        } else if (type === "farmasi") {
          res.map((item) => {
            if (item.kategori === 1) {
              return data.push({
                value: item.id,
                label: item.name,
              });
            }
          });
        } else if (type === "logistik") {
          res.map((item) => {
            if (item.kategori === 2) {
              return data.push({
                value: item.id,
                label: item.name,
              });
            }
          });
        }

        setState(data);
      }
    })();
  }, [withSearch, url]);

  return state;
};

export default useInitialMasterSupplier;
